import React from "react";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import axios from "../../utils/axios.tsx";
import { conversationActions } from "../../store/conversation.tsx";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../hooks.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

interface ThumbUpPromptProps {
  exchange_id: string | undefined;
  clicked: boolean | false;
}

const ThumbUpPrompt: React.FC<ThumbUpPromptProps> = (props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const anonymousSession = useTypedSelector(
    (state) => state.authState.anonymousSession,
  );
  const selectedConversationId = useTypedSelector(
    (state) => state.conversationState.selectedConversation,
  );

  const handleOnClick = async () => {
    const slug = anonymousSession
      ? "/v1/anonymous/good-response/"
      : "/v1/good-response/";
    await axios
      .post(slug, JSON.stringify({ exchange_id: props.exchange_id }))
      .then(() => {
        dispatch(
          conversationActions.updateExchangeById({
            id: props.exchange_id,
            updateFields: { feedback: "good" },
            conversationId: selectedConversationId,
          }),
        );
      });
  };

  return (
    <Box>
      <Tooltip
        title={i18n._(
          msg({
            context:
              "Title of a button which allows the user to mark the response by the application as good-one.",
            message: "Good Response",
          }),
        )}
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "0.9rem",
            },
          },
        }}
      >
        <span>
          <IconButton
            onClick={handleOnClick}
            size="small"
            disabled={props.clicked}
          >
            {props.clicked ? (
              <ThumbUpAltIcon
                fontSize="small"
                style={{ color: theme.palette.primary.main }}
              /> // Filled icon if clicked is true
            ) : (
              <ThumbUpAltOutlinedIcon fontSize="small" /> // Outlined icon otherwise
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default ThumbUpPrompt;
